import React from 'react';
import SecurityIPSetting from './SecurityIPSetting';
import { IP_RANGE } from './Tenant';

const Security = ({
    isRunRestrictedByIPRange = false,
    isDrawRestrictedByIPRange = false,
    isAdminRestrictedByIPRange = false,
    isPackagingRestrictedByIPRange = false,
    authorizedAdminIPRanges,
    authorizedDrawIPRanges,
    authorizedPackagingIPRanges,
    authorizedRunIPRanges,
}) => (
    <div className="form-group">

        <SecurityIPSetting
            IPRange={IP_RANGE.run}
            isActive={isRunRestrictedByIPRange}
            settingPropertyName="isRunRestrictedByIPRange"
            rangeEntries={authorizedRunIPRanges}
            labelText="Restrict run access by IP address"
        />

        <SecurityIPSetting
            IPRange={IP_RANGE.draw}
            isActive={isDrawRestrictedByIPRange}
            settingPropertyName="isDrawRestrictedByIPRange"
            rangeEntries={authorizedDrawIPRanges}
            labelText="Restrict draw access by IP address"
        />

        <SecurityIPSetting
            IPRange={IP_RANGE.admin}
            isActive={isAdminRestrictedByIPRange}
            settingPropertyName="isAdminRestrictedByIPRange"
            rangeEntries={authorizedAdminIPRanges}
            labelText="Restrict admin access by IP address"
        />

        <SecurityIPSetting
            IPRange={IP_RANGE.packaging}
            isActive={isPackagingRestrictedByIPRange}
            settingPropertyName="isPackagingRestrictedByIPRange"
            rangeEntries={authorizedPackagingIPRanges}
            labelText="Restrict package access by IP address"
        />
    </div>
);

export default Security;
